export default __webpack_public_path__ + "static/media/agnidus_agate_fragment.433163af.png";